/**
 * @fileoverview CategoryList Component
 *
 * Handles rendering the list of category rows for non-adjustment transactions.
 * Manages category selection, amount distribution, and row removal logic.
 * Prevents removal of the first category when multiple categories exist to maintain
 * auto-adjustment functionality.
 *
 * @module components/TransactionForm/CategoryList
 */
import CategoryRow from './CategoryRow';
import styles from './CategoryList.module.css';

function CategoryList({
    transactionType,
    amount,
    transactionCategories,
    errors,
    onCategoryChange,
    clearCategoryError,
    getAvailableCategories,
    getAvailableCategoriesForExpenses,
    getAvailableCategoriesForTransfers,
    isGrandfatheredCategory,
    isEdit
}) {
    const getAvailableCategoriesForRow = (index) => {
        if (transactionType === 'Expense') {
            return getAvailableCategoriesForExpenses(index, isEdit);
        } else if (transactionType === 'Transfer') {
            return getAvailableCategoriesForTransfers(index, isEdit);
        }
        return getAvailableCategories(index, isEdit);
    };

    const canRemoveRow = (index) => {
        // First category (index 0) cannot be removed when multiple categories exist
        if (index === 0 && transactionCategories.length > 1) {
            return false;
        }
        return transactionCategories.length > 1 && transactionType !== 'Transfer';
    };

    const canAddCategory = (index) => {
        const isLastRow = index === transactionCategories.length - 1;
        const hasAvailableCategories = getAvailableCategoriesForRow(index).length > 0;
        const isNotTransfer = transactionType !== 'Transfer';

        return isLastRow && hasAvailableCategories && isNotTransfer;
    };

    return (
        <div className={styles.categoryList}>
            {transactionCategories.map((catItem, index) => (
                <CategoryRow
                    key={index}
                    catItem={catItem}
                    index={index}
                    transactionType={transactionType}
                    amount={amount}
                    availableCategories={getAvailableCategoriesForRow(index)}
                    errors={errors}
                    isLastRow={index === transactionCategories.length - 1}
                    canRemove={canRemoveRow(index)}
                    canAdd={canAddCategory(index)}
                    onCategoryChange={onCategoryChange}
                    clearCategoryError={clearCategoryError}
                    isGrandfatheredCategory={isGrandfatheredCategory}
                    isEdit={isEdit}
                />
            ))}
        </div>
    );
}

export default CategoryList;
